import React from 'react';
import './style.scss';
import cl from 'classnames';

const PaymentCardMessage = ({ isSuccess, message, actions }) => {
    return (
        <div className="card-result-container">                    
            <div className={cl('svg', { 'success': isSuccess, 'error': !isSuccess })} />

            <h3>{message}</h3>

            <div className="action-return">
                <div className="actions-container">
                    {actions && actions.map((action, i) => (
                        <button className="primary" key={i} type="button" onClick={(e) => action.onClick(e)}>{action.label}</button>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default PaymentCardMessage;